(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2742],{

/***/ 39844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sM": function() { return /* binding */ getSearchSuggestionList; },
/* harmony export */   "vz": function() { return /* binding */ getCityList; }
/* harmony export */ });
/* unused harmony exports getPartners, getExchangeRates */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58081);



var getSearchSuggestionList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(query) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (query.length < 3) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/search/".concat(query))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getSearchSuggestionList(query) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Get list of suggestions for cities
 *
 * @param query string possible city string
 * @returns SearchQueryResult
 */ var getCityList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(query) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!query) {
                        return [
                            2,
                            []
                        ];
                    }
                    if (query.length < 3) {
                        return [
                            2,
                            []
                        ];
                    }
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/cities/search/".concat(query))
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getCityList(query) {
        return _ref.apply(this, arguments);
    };
}();
var getPartners = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/partners")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getPartners() {
        return _ref.apply(this, arguments);
    };
}();
var getExchangeRates = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("currencies/exchange-rates")
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getExchangeRates() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 42742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ search_bar_SearchBarContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs
var useQuery = __webpack_require__(36492);
// EXTERNAL MODULE: ./api/misc.ts
var misc = __webpack_require__(39844);
// EXTERNAL MODULE: ./hooks/useDebounce.ts
var useDebounce = __webpack_require__(4841);
// EXTERNAL MODULE: ./blocks/search-bar/context.tsx
var context = __webpack_require__(62643);
;// CONCATENATED MODULE: ./blocks/search-bar/queries.ts
var GET_SEARCH_SUGGESTION_LIST = "GET_SEARCH_SUGGESTION_LIST";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./customHooks/useLocalised/useLocalised.ts + 2 modules
var useLocalised = __webpack_require__(91933);
// EXTERNAL MODULE: ./data/translationKeys.ts
var translationKeys = __webpack_require__(698);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./data/constants.ts
var constants = __webpack_require__(84749);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./components/icons/index.ts + 18 modules
var icons = __webpack_require__(30918);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./assets/svg/Hotel.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

const SvgHotel = props => /*#__PURE__*/react.createElement("svg", _extends({
  width: 15,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  d: "M2.143 2.167c-.882 0-1.607.67-1.607 1.485v3.359A1.433 1.433 0 0 0 0 8.11v4.457h2.679v-.991h9.642v.991H15V8.11c0-.435-.209-.826-.536-1.1V3.653c0-.814-.725-1.485-1.607-1.485H2.143Zm0 .99h10.714c.297 0 .536.22.536.495v2.972H12.32v-.495c0-.815-.725-1.486-1.607-1.486H8.571c-.41 0-.786.149-1.071.387a1.671 1.671 0 0 0-1.071-.387H4.286c-.882 0-1.607.67-1.607 1.486v.495H1.607V3.652c0-.274.239-.495.536-.495Zm2.143 2.476h2.143c.297 0 .535.221.535.496v.495H3.75v-.495c0-.275.239-.496.536-.496Zm4.285 0h2.143c.297 0 .536.221.536.496v.495H8.036v-.495c0-.275.238-.496.535-.496ZM1.607 7.614h11.786c.297 0 .536.221.536.496v3.466h-.536v-.99H1.607v.99h-.536V8.11c0-.275.24-.496.536-.496Z",
  fill: "#BAA57E"
})));
/* harmony default export */ var Hotel = (SvgHotel);
;// CONCATENATED MODULE: ./assets/svg/Location.svg
var Location_path;
function Location_extends() { return Location_extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, Location_extends.apply(null, arguments); }

const SvgLocation = props => /*#__PURE__*/react.createElement("svg", Location_extends({
  width: 15,
  height: 13,
  viewBox: "0 0 13 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), Location_path || (Location_path = /*#__PURE__*/react.createElement("path", {
  d: "M6.5 13c-.811 0-4.875-6.094-4.875-8.125A4.89 4.89 0 0 1 6.5 0a4.89 4.89 0 0 1 4.875 4.875C11.375 6.905 7.311 13 6.5 13ZM6.5.811a4.073 4.073 0 0 0-4.061 4.061c0 1.706 3.372 6.906 4.061 6.906.65 0 4.061-5.242 4.061-6.906A4.075 4.075 0 0 0 6.5.812Zm0 6.095a2.012 2.012 0 0 1-2.03-2.031c0-1.136.894-2.03 2.03-2.03 1.136 0 2.03.894 2.03 2.03 0 1.136-.894 2.03-2.03 2.03Zm0-3.25c-.692 0-1.22.527-1.22 1.219 0 .692.528 1.22 1.22 1.22s1.22-.528 1.22-1.22-.528-1.22-1.22-1.22Z",
  fill: "#BAA57E"
})));
/* harmony default export */ var Location = (SvgLocation);
// EXTERNAL MODULE: ./components/text/index.ts
var components_text = __webpack_require__(22538);
// EXTERNAL MODULE: ./blocks/search-bar/Suggestion.module.scss
var Suggestion_module = __webpack_require__(36194);
var Suggestion_module_default = /*#__PURE__*/__webpack_require__.n(Suggestion_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./components/icons/InspirationCategories/InspirationCategoriesIcons.tsx
/* eslint-disable react/jsx-key */ 



var InspirationCategoriesIcons = function(_param) {
    var icon = _param.icon, props = (0,_object_without_properties/* default */.Z)(_param, [
        "icon"
    ]);
    var icons = new Map([
        [
            "star",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_NewOpenings, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "family",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Families, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "suitcase",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Suitcase, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "snowflake",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Snowflake, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "beach",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Beach, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "countryside",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_CountrySide, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "balloon",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Balloon, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "gift",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Gift, (0,_object_spread/* default */.Z)({}, props))
        ],
        [
            "leaf",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories_Wellness, (0,_object_spread/* default */.Z)({}, props))
        ], 
    ]);
    return icons.get(icon) || /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
};
/* harmony default export */ var InspirationCategories_InspirationCategoriesIcons = (InspirationCategoriesIcons);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/NewOpenings.tsx

var NewOpenings = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "17",
        viewBox: "0 0 19 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.9279 16.4792L14.9278 16.4789L13.7776 11.0368L17.9988 7.28679L17.9992 7.28645C18.0429 7.2472 18.0745 7.19625 18.0897 7.13945C18.105 7.08264 18.1032 7.02273 18.0846 6.96693C18.0659 6.91117 18.0314 6.86217 17.9854 6.82553C17.9395 6.78891 17.884 6.76609 17.8256 6.75943L17.8252 6.75938L12.1395 6.13847L9.78134 1.07621L9.78096 1.07542C9.75574 1.0225 9.71568 0.97811 9.6659 0.947185C9.61613 0.916268 9.55857 0.9 9.5 0.9C9.44143 0.9 9.38388 0.916269 9.33411 0.947185C9.28432 0.97811 9.24427 1.0225 9.21904 1.07542L9.21867 1.07621L6.86045 6.13847L1.17482 6.75938L1.17434 6.75943C1.11597 6.76609 1.06051 6.78893 1.01459 6.82554C0.968635 6.86218 0.934082 6.91117 0.915446 6.96694C0.896803 7.02273 0.89499 7.08264 0.910257 7.13946C0.925519 7.19625 0.957105 7.2472 1.00085 7.28645L1.00122 7.28679L5.22239 11.0368L4.07215 16.4789L4.07197 16.4798C4.06036 16.5374 4.06594 16.5969 4.08794 16.6513C4.10992 16.7057 4.14726 16.7524 4.19517 16.7862C4.24306 16.82 4.2996 16.8395 4.35807 16.8429C4.41654 16.8462 4.47495 16.8333 4.52646 16.8053L4.5271 16.805L9.49999 14.0557L14.4725 16.8048C14.4726 16.8048 14.4727 16.8049 14.4728 16.8049C14.5267 16.8349 14.5884 16.8484 14.6499 16.8437L14.6423 16.744L14.6508 16.8436C14.694 16.8399 14.7359 16.8274 14.7739 16.8068C14.812 16.7862 14.8454 16.7579 14.8717 16.7236C14.8981 16.6892 14.9168 16.6497 14.9266 16.6075C14.9363 16.5653 14.9368 16.5216 14.9279 16.4792ZM9.65131 13.4448L9.65085 13.4445C9.60463 13.4193 9.55269 13.4061 9.5 13.4061C9.44731 13.4061 9.39538 13.4193 9.34915 13.4445L9.34869 13.4448L4.81848 15.9501L5.86567 10.9901C5.86572 10.9899 5.86576 10.9897 5.86581 10.9895C5.87739 10.9371 5.8747 10.8828 5.85803 10.8318C5.84131 10.7807 5.81119 10.735 5.77099 10.6993L5.77091 10.6992L1.92927 7.28993L7.10159 6.72564L7.10211 6.72558C7.15445 6.71959 7.20455 6.7006 7.24756 6.67017C7.29059 6.63974 7.32515 6.59884 7.34765 6.55116L7.34785 6.55074L9.49999 1.935L11.6521 6.55074L11.6523 6.55116C11.6748 6.59884 11.7094 6.63974 11.7524 6.67017C11.7954 6.7006 11.8455 6.71959 11.8979 6.72558L11.8984 6.72564L17.0707 7.28993L13.2291 10.6992L13.229 10.6993C13.1888 10.735 13.1587 10.7807 13.142 10.8318C13.1253 10.8827 13.1226 10.9371 13.1342 10.9894C13.1342 10.9897 13.1343 10.9899 13.1343 10.9901L14.1815 15.9501L9.65131 13.4448Z",
            fill: "#BAA57E",
            stroke: "#BAA57E",
            strokeWidth: "0.2"
        })
    });
};
/* harmony default export */ var InspirationCategories_NewOpenings = (NewOpenings);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Families.tsx

var Families = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "15",
        viewBox: "0 0 18 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M10.4012 14.6865C10.401 14.6865 10.401 14.6865 10.4012 14.6865H9.45365C9.09005 14.6864 8.78495 14.4138 8.74391 14.0526L8.16071 8.69235C7.78001 8.49795 7.51397 8.11852 7.46807 7.68813L7.11635 5.02305C7.10933 4.96311 7.10609 4.90659 7.10627 4.85007C7.10717 4.04583 7.76273 3.39081 8.56787 3.39081H9.36527C8.71871 3.15465 8.25575 2.53329 8.25575 1.80609C8.25683 0.878013 9.01247 0.122913 9.94019 0.122913C10.8693 0.122913 11.6252 0.878733 11.6252 1.80753C11.6252 2.53419 11.1627 3.15483 10.5165 3.39063H11.3116C11.3665 3.39063 11.4214 3.39369 11.4759 3.39999C12.2773 3.49053 12.8556 4.21665 12.7651 5.01837L12.4087 7.69587C12.359 8.12805 12.0851 8.50696 11.6955 8.69559L11.1113 14.0511C11.0699 14.4138 10.7648 14.6864 10.4012 14.6865ZM8.56913 3.87249C8.02787 3.87249 7.58831 4.31151 7.58777 4.85133C7.58759 4.88931 7.58975 4.92657 7.59407 4.96383L7.94597 7.63125C7.97873 7.93761 8.18285 8.19825 8.46707 8.30157C8.55329 8.33289 8.61413 8.41066 8.62421 8.50191L9.22235 13.9995C9.23549 14.1161 9.33503 14.205 9.45365 14.205H10.4008C10.5194 14.205 10.6191 14.1161 10.6325 13.9982L11.232 8.50173C11.2423 8.40849 11.3057 8.32965 11.3944 8.29959C11.6851 8.20167 11.8955 7.94139 11.9306 7.63683L12.287 4.95969C12.3471 4.42653 11.9592 3.93945 11.4214 3.87861C11.3847 3.87447 11.348 3.87249 11.3114 3.87249H8.56913ZM9.94019 0.604773C9.27761 0.604773 8.73797 1.14387 8.73725 1.80645C8.73725 2.46993 9.27689 3.01029 9.94037 3.01083C10.604 3.01083 11.1437 2.47101 11.1437 1.80771C11.1435 1.14441 10.6037 0.604773 9.94019 0.604773ZM15.2108 14.6849C15.2106 14.6849 15.2097 14.6849 15.2095 14.6849H14.5095C14.21 14.6849 13.9594 14.4608 13.9261 14.1638L13.5096 11.3897C13.2291 11.234 13.04 10.9528 13.0041 10.627L12.7462 8.68065C12.7408 8.63493 12.7385 8.59227 12.7385 8.54961C12.7381 8.24703 12.8556 7.96245 13.0697 7.74807C13.2835 7.53387 13.5681 7.41561 13.8708 7.41525H14.1745C13.8154 7.18431 13.5769 6.78129 13.5769 6.32373C13.5783 5.61039 14.1592 5.03025 14.872 5.03025C15.5861 5.03025 16.1669 5.61129 16.1669 6.32517C16.1669 6.78219 15.9291 7.18449 15.5706 7.41507H15.876C15.9182 7.41507 15.9605 7.41759 16.0022 7.42227C16.3034 7.45629 16.573 7.60533 16.7616 7.84221C16.9503 8.07909 17.0354 8.37501 17.0012 8.67597L16.739 10.6387C16.7013 10.9656 16.4988 11.2539 16.209 11.4053L15.7925 14.1725C15.7601 14.4608 15.5096 14.6849 15.2108 14.6849ZM13.8712 7.89693C13.6971 7.89711 13.5335 7.96497 13.4106 8.08827C13.2875 8.21139 13.22 8.37519 13.2201 8.54925C13.2201 8.57337 13.2214 8.59731 13.2239 8.62071L13.4822 10.569C13.504 10.7685 13.6307 10.9321 13.8136 11.001C13.8951 11.0318 13.9536 11.1044 13.9668 11.1906L14.4036 14.101C14.4107 14.1631 14.4555 14.2031 14.5089 14.2031H15.2108C15.2642 14.2031 15.309 14.1629 15.315 14.1098L15.7529 11.2017C15.7662 11.1125 15.8285 11.0383 15.914 11.0095C16.1021 10.946 16.2386 10.7771 16.2612 10.5793L16.5235 8.61693C16.5426 8.44863 16.4936 8.27853 16.3851 8.14227C16.2765 8.00601 16.1216 7.92051 15.9484 7.90089C15.9246 7.89819 15.9003 7.89693 15.8762 7.89693H13.8712ZM14.872 5.51211C14.4243 5.51211 14.0591 5.87643 14.0584 6.32427C14.0584 6.77265 14.4234 7.13823 14.8722 7.13895C15.3204 7.13895 15.6852 6.77391 15.6852 6.32535C15.6852 5.87679 15.3204 5.51211 14.872 5.51211ZM4.40375 14.6768C4.40357 14.6768 4.40177 14.6768 4.40159 14.6768H3.75539C3.39035 14.6768 3.08489 14.4041 3.04403 14.0429L2.81093 11.4383H1.74731C1.70843 11.4375 1.67369 11.4339 1.63949 11.4273C1.33259 11.3643 1.13531 11.0657 1.19777 10.7609L1.56317 9.23703C1.18229 9.14415 0.936229 8.77569 1.00211 8.39013L1.92353 4.48197C2.05583 3.91353 2.51447 3.48927 3.09191 3.40179C3.13097 3.39621 3.30395 3.39315 3.52157 3.39135C2.86475 3.16077 2.39261 2.53437 2.39261 1.79961C2.39261 0.869733 3.14915 0.113373 4.07903 0.113373C5.00873 0.113373 5.76527 0.869913 5.76527 1.79961C5.76527 2.53401 5.29349 3.16023 4.63703 3.39117C5.01737 3.39387 5.05463 3.39945 5.06957 3.40161C5.64827 3.48927 6.10709 3.91353 6.23885 4.48287L7.15559 8.42217C7.20509 8.80161 6.95813 9.15225 6.59507 9.24009L6.96137 10.7543C6.97055 10.7969 6.97397 10.8326 6.97469 10.8682C6.97775 11.181 6.72701 11.4366 6.41597 11.4395H5.34083L5.11457 14.0366C5.07263 14.4043 4.76717 14.6768 4.40375 14.6768ZM4.40231 14.1951H4.40375C4.52237 14.1951 4.62191 14.1062 4.63541 13.9883L4.88021 11.1782C4.89119 11.0538 4.99541 10.9582 5.12015 10.9582H6.41381C6.45701 10.9578 6.49373 10.9204 6.49319 10.8749L6.05525 9.05649C6.03491 8.97243 6.06119 8.88387 6.12419 8.82465C6.18719 8.76525 6.27719 8.74437 6.35981 8.76975C6.38987 8.77875 6.42173 8.78163 6.45359 8.77749C6.59615 8.75877 6.69695 8.62773 6.67823 8.48535L5.77013 4.59195C5.68301 4.21575 5.38007 3.93567 4.99847 3.87789C4.95995 3.87501 4.63199 3.87105 4.09775 3.87105C3.54983 3.87105 3.20261 3.87519 3.15419 3.87897C2.78285 3.93531 2.48009 4.21575 2.39261 4.59159L1.47389 8.48589C1.45283 8.61279 1.54823 8.74779 1.68989 8.77209C1.71401 8.77533 1.72373 8.77587 1.73327 8.77587C1.75541 8.77587 1.77737 8.77263 1.79843 8.76615C1.88087 8.74095 1.97069 8.76201 2.03369 8.82123C2.09669 8.88045 2.12297 8.96865 2.10281 9.05271L1.66793 10.8653C1.66379 10.8866 1.67459 10.9087 1.68161 10.9193C1.68863 10.9301 1.70501 10.9488 1.73417 10.9548C1.73831 10.9557 1.74515 10.9564 1.75145 10.9564H3.03125C3.15581 10.9564 3.26003 11.0516 3.27101 11.1758L3.52301 13.9941C3.53579 14.1062 3.63533 14.1951 3.75395 14.1951H4.40231ZM4.07903 0.595053C3.41483 0.595053 2.87429 1.13541 2.87429 1.79961C2.87429 2.46399 3.41483 3.00435 4.07903 3.00435C4.74323 3.00435 5.28359 2.46399 5.28359 1.79961C5.28377 1.13541 4.74341 0.595053 4.07903 0.595053Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Families = (Families);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Suitcase.tsx

var Suitcase = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "16",
        viewBox: "0 0 24 21",
        fill: "#BAA57E",
        stroke: "#BAA57E",
        strokeWidth: "0.2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.4314 19.9222C19.6907 19.9222 17.95 19.9222 16.2093 19.9222C13.0923 19.9222 9.97521 19.9222 6.85817 19.9222C5.75506 19.9222 4.64689 19.9222 3.54378 19.9222C2.82524 19.9222 1.85369 20.069 1.56526 19.1936C1.4843 18.9456 1.5096 18.6572 1.5096 18.4042C1.5096 17.9386 1.5096 17.4731 1.5096 17.0076C1.5096 15.525 1.5096 14.0423 1.5096 12.5547C1.5096 11.072 1.5096 9.58436 1.5096 8.10174C1.5096 7.60584 1.5096 7.10995 1.5096 6.61912C1.5096 6.40659 1.48936 6.17383 1.51466 5.9613C1.59056 5.3642 2.11682 5.04036 2.67849 5.04036C2.93656 5.04036 3.18957 5.04036 3.44763 5.04036C4.54062 5.04036 5.63361 5.04036 6.7266 5.04036C9.83859 5.04036 12.9556 5.04036 16.0676 5.04036C17.8538 5.04036 19.6401 4.99987 21.4263 5.04036C22.0791 5.05554 22.4889 5.57167 22.4889 6.19407C22.4889 6.52297 22.4889 6.85694 22.4889 7.18585C22.4889 8.52679 22.4889 9.86266 22.4889 11.2036C22.4889 13.7134 22.4889 16.2283 22.4889 18.7381C22.494 19.3707 22.1044 19.907 21.4314 19.9222C21.1075 19.9323 21.1075 20.4383 21.4314 20.4282C22.3219 20.4029 22.9949 19.7046 23 18.814C23 18.5256 23 18.2372 23 17.9437C23 16.5977 23 15.2517 23 13.9057C23 11.3352 23 8.76967 23 6.19913C23 5.50083 22.6407 4.86831 21.9627 4.62036C21.6894 4.51916 21.4111 4.52422 21.1278 4.52422C20.2321 4.52422 19.3415 4.52422 18.4459 4.52422C15.3187 4.52422 12.1915 4.52422 9.06439 4.52422C6.93407 4.52422 4.80375 4.51916 2.67343 4.52422C2.05104 4.52422 1.46406 4.80253 1.17563 5.37938C0.998528 5.72853 1.00359 6.07768 1.00359 6.45213C1.00359 7.59572 1.00359 8.74437 1.00359 9.88796C1.00359 12.7166 1.00359 15.5452 1.00359 18.3738C1.00359 18.642 0.983348 18.9254 1.03901 19.1885C1.19587 19.9374 1.88405 20.413 2.62789 20.4181C3.31607 20.4232 4.00931 20.4181 4.69749 20.4181C7.70321 20.4181 10.7089 20.4181 13.7096 20.4181C16.1536 20.4181 18.5977 20.4181 21.0367 20.4181C21.1682 20.4181 21.2998 20.4181 21.4263 20.4181C21.7552 20.4282 21.7552 19.9222 21.4314 19.9222Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M21.4314 19.9222C19.6907 19.9222 17.95 19.9222 16.2093 19.9222C13.0923 19.9222 9.97521 19.9222 6.85817 19.9222C5.75506 19.9222 4.64689 19.9222 3.54378 19.9222C2.82524 19.9222 1.85369 20.069 1.56526 19.1936C1.4843 18.9456 1.5096 18.6572 1.5096 18.4042C1.5096 17.9386 1.5096 17.4731 1.5096 17.0076C1.5096 15.525 1.5096 14.0423 1.5096 12.5547C1.5096 11.072 1.5096 9.58436 1.5096 8.10174C1.5096 7.60584 1.5096 7.10995 1.5096 6.61912C1.5096 6.40659 1.48936 6.17383 1.51466 5.9613C1.59056 5.3642 2.11682 5.04036 2.67849 5.04036C2.93656 5.04036 3.18957 5.04036 3.44763 5.04036C4.54062 5.04036 5.63361 5.04036 6.7266 5.04036C9.83859 5.04036 12.9556 5.04036 16.0676 5.04036C17.8538 5.04036 19.6401 4.99987 21.4263 5.04036C22.0791 5.05554 22.4889 5.57167 22.4889 6.19407C22.4889 6.52297 22.4889 6.85694 22.4889 7.18585C22.4889 8.52679 22.4889 9.86266 22.4889 11.2036C22.4889 13.7134 22.4889 16.2283 22.4889 18.7381C22.494 19.3707 22.1044 19.907 21.4314 19.9222ZM21.4314 19.9222C21.1075 19.9323 21.1075 20.4383 21.4314 20.4282C22.3219 20.4029 22.9949 19.7046 23 18.814C23 18.5256 23 18.2372 23 17.9437C23 16.5977 23 15.2517 23 13.9057C23 11.3352 23 8.76967 23 6.19913C23 5.50083 22.6407 4.86831 21.9627 4.62036C21.6894 4.51916 21.4111 4.52422 21.1278 4.52422C20.2321 4.52422 19.3415 4.52422 18.4459 4.52422C15.3187 4.52422 12.1915 4.52422 9.06439 4.52422C6.93407 4.52422 4.80375 4.51916 2.67343 4.52422C2.05104 4.52422 1.46406 4.80253 1.17563 5.37938C0.998528 5.72853 1.00359 6.07768 1.00359 6.45213C1.00359 7.59572 1.00359 8.74437 1.00359 9.88796C1.00359 12.7166 1.00359 15.5452 1.00359 18.3738C1.00359 18.642 0.983348 18.9254 1.03901 19.1885C1.19587 19.9374 1.88405 20.413 2.62789 20.4181C3.31607 20.4232 4.00931 20.4181 4.69749 20.4181C7.70321 20.4181 10.7089 20.4181 13.7096 20.4181C16.1536 20.4181 18.5977 20.4181 21.0367 20.4181C21.1682 20.4181 21.2998 20.4181 21.4263 20.4181C21.7552 20.4282 21.7552 19.9222 21.4314 19.9222Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M5.42688 4.78233C5.42688 6.52807 5.42688 8.27382 5.42688 10.0196C5.42688 12.7773 5.42688 15.5351 5.42688 18.2929C5.42688 18.9203 5.42688 19.5529 5.42688 20.1803C5.42688 20.5042 5.93289 20.5042 5.93289 20.1803C5.93289 18.4346 5.93289 16.6888 5.93289 14.9431C5.93289 12.1853 5.93289 9.42753 5.93289 6.66976C5.93289 6.0423 5.93289 5.40978 5.93289 4.78233C5.93289 4.45342 5.42688 4.45342 5.42688 4.78233Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M18.0671 4.78233C18.0671 6.52807 18.0671 8.27382 18.0671 10.0196C18.0671 12.7773 18.0671 15.5351 18.0671 18.2929C18.0671 18.9203 18.0671 19.5529 18.0671 20.1803C18.0671 20.5042 18.5732 20.5042 18.5732 20.1803C18.5732 18.4346 18.5732 16.6888 18.5732 14.9431C18.5732 12.1853 18.5732 9.42753 18.5732 6.66976C18.5732 6.0423 18.5732 5.40978 18.5732 4.78233C18.5732 4.45342 18.0671 4.45342 18.0671 4.78233Z"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.0743 4.78227C9.0743 4.06373 9.0743 3.35025 9.0743 2.63172C9.0743 2.15606 9.22104 1.72089 9.65115 1.46788C9.94464 1.29584 10.2533 1.31102 10.5721 1.31102C11.4424 1.31102 12.3128 1.31102 13.1831 1.31102C13.421 1.31102 13.6689 1.29078 13.9017 1.31608C14.4988 1.38692 14.9188 1.90306 14.9238 2.49003C14.9339 3.25411 14.9238 4.01819 14.9238 4.77721C14.9238 5.10106 15.4298 5.10106 15.4298 4.77721C15.4298 4.02325 15.4349 3.27435 15.4298 2.52039C15.4248 1.92836 15.1616 1.38692 14.6607 1.06307C14.3065 0.835368 13.9168 0.799947 13.512 0.799947C12.586 0.799947 11.6651 0.799947 10.7391 0.799947C10.4355 0.799947 10.1167 0.774646 9.8232 0.850548C9.1249 1.02765 8.61888 1.65005 8.56828 2.36353C8.50756 3.15797 8.56322 3.97771 8.56322 4.77721C8.56828 5.10612 9.0743 5.10612 9.0743 4.78227Z"
                })
            ]
        })
    });
};
/* harmony default export */ var InspirationCategories_Suitcase = (Suitcase);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Snowflake.tsx

var Snowflake = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 20 23",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10.0014 0.344818C10.2775 0.344818 10.5014 0.568676 10.5014 0.844818V4.30661L12.1484 2.71557C12.347 2.52371 12.6635 2.52919 12.8554 2.7278C13.0473 2.92641 13.0418 3.24294 12.8432 3.4348L10.5014 5.69698V10.3767L14.5554 8.03333L15.3408 4.87602C15.4074 4.60804 15.6787 4.44484 15.9467 4.5115C16.2147 4.57816 16.3779 4.84943 16.3112 5.11741L15.7589 7.33766L18.75 5.60877C18.989 5.47057 19.2949 5.55236 19.4331 5.79143C19.5713 6.03051 19.4895 6.33634 19.2504 6.47454L16.2564 8.20517L18.4582 8.8364C18.7237 8.9125 18.8772 9.18938 18.8011 9.45483C18.725 9.72028 18.4481 9.87378 18.1826 9.79768L15.0533 8.90056L10.9995 11.2438L15.0503 13.5827L18.1826 12.6848C18.4481 12.6087 18.725 12.7622 18.8011 13.0276C18.8772 13.2931 18.7237 13.57 18.4582 13.6461L16.2542 14.2779L19.2502 16.0078C19.4893 16.1459 19.5713 16.4517 19.4332 16.6908C19.2951 16.93 18.9893 17.0119 18.7502 16.8738L15.7595 15.147L16.3112 17.3651C16.3779 17.6331 16.2147 17.9043 15.9467 17.971C15.6787 18.0376 15.4074 17.8744 15.3408 17.6065L14.5562 14.4521L10.5014 12.1108V16.7847L12.8432 19.0475C13.0418 19.2394 13.0472 19.5559 12.8554 19.7545C12.6635 19.9531 12.3469 19.9585 12.1484 19.7666L10.5014 18.1753V21.6375C10.5014 21.9136 10.2775 22.1375 10.0014 22.1375C9.72521 22.1375 9.50135 21.9136 9.50135 21.6375V18.1751L7.85374 19.7667C7.65513 19.9585 7.3386 19.9531 7.14674 19.7544C6.95488 19.5558 6.96036 19.2393 7.15897 19.0474L9.50135 16.7847V12.1093L5.4499 14.4486L4.65897 17.6071C4.59189 17.875 4.32036 18.0377 4.05249 17.9706C3.78462 17.9036 3.62184 17.632 3.68892 17.3642L4.24477 15.1445L1.25002 16.8737C1.01088 17.0118 0.705081 16.9298 0.566999 16.6907C0.428918 16.4516 0.510842 16.1458 0.749982 16.0077L3.74717 14.2771L1.54244 13.646C1.27697 13.57 1.12336 13.2931 1.19935 13.0277C1.27535 12.7622 1.55217 12.6086 1.81765 12.6846L4.95154 13.5817L9.0005 11.2438L4.9485 8.90155L1.81762 9.79759C1.55214 9.87357 1.27533 9.71995 1.19935 9.45446C1.12337 9.18898 1.27699 8.91217 1.54247 8.83619L3.74495 8.20585L0.749768 6.47452C0.510693 6.33633 0.428913 6.03049 0.567108 5.79141C0.705303 5.55234 1.01114 5.47056 1.25022 5.60875L4.24577 7.3403L3.68894 5.11809C3.62182 4.85023 3.78455 4.57867 4.05242 4.51156C4.32028 4.44444 4.59183 4.60717 4.65895 4.87503L5.45129 8.03714L9.50135 10.3782V5.69805L7.15893 3.43476C6.96034 3.24288 6.9549 2.92634 7.14678 2.72776C7.33866 2.52917 7.65519 2.52373 7.85378 2.71561L9.50135 4.30752V0.844818C9.50135 0.568676 9.72521 0.344818 10.0014 0.344818Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Snowflake = (Snowflake);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Beach.tsx

var Beach = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "17",
        viewBox: "0 0 18 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M17.0995 10.069L16.7956 9.84561L13.9941 13.5542L13.4154 11.8138H8.85345L8.3128 13.4693L6.52106 6.79162C6.83055 6.72154 7.15063 6.71168 7.46385 6.76258C7.73417 6.81619 7.91066 6.9279 7.94864 7.06865L8.31503 6.97035C8.22343 6.633 8.62557 6.21969 9.18856 6.07671C9.75155 5.93373 10.3056 6.07671 10.3972 6.42076L10.7658 6.32246C10.672 5.97841 10.9669 5.60085 11.4226 5.47798C11.8784 5.3551 12.3163 5.5383 12.4123 5.88235L12.7787 5.78405C12.3465 4.14452 11.2907 2.73881 9.83651 1.8669C8.38234 0.994976 6.64499 0.725885 4.99518 1.11704L4.69358 0L4.32496 0.0893633L4.62656 1.20641C3.0062 1.69437 1.63996 2.79491 0.818141 4.27419C-0.0036823 5.75347 -0.216319 7.4949 0.22541 9.12847L0.5918 9.0257C0.572353 8.94136 0.572302 8.85371 0.591651 8.76934C0.611001 8.68498 0.649246 8.60611 0.703504 8.53867C0.842305 8.3645 1.0332 8.23931 1.24826 8.18143C1.46332 8.12354 1.69126 8.13599 1.89874 8.21696C1.97977 8.24874 2.05259 8.29839 2.11177 8.36222C2.17095 8.42604 2.21497 8.50239 2.24056 8.58559L2.60694 8.48729C2.51535 8.14771 2.91748 7.7344 3.48047 7.59365C3.74906 7.51632 4.03402 7.51632 4.30262 7.59365C4.39001 7.61557 4.47081 7.65831 4.53811 7.71822C4.60541 7.77813 4.65722 7.85343 4.68911 7.9377L4.87231 7.88855L5.05774 7.8394C4.98401 7.56685 5.43083 7.1245 6.15244 6.88322L7.99332 13.7463L7.84364 13.762C5.35487 14.0368 2.6829 15.194 2.51758 16.6551L2.89514 16.6976C3.02025 15.5961 5.30572 14.4255 7.88385 14.1395L8.09162 14.1172V14.1328L7.28289 16.6216L7.64481 16.74L8.27705 14.8097L8.76185 16.6216L9.12824 16.5233L8.49152 14.1395L8.51387 14.077C10.269 13.9771 12.0288 13.9928 13.7818 14.1239L14.6487 16.7311L15.0084 16.6216L14.1393 13.9921L17.0995 10.069ZM4.42549 3.42485C4.43666 2.1894 4.67794 1.5728 4.91252 1.51024C4.92881 1.50776 4.94538 1.50776 4.96167 1.51024C5.21189 1.51024 5.70339 1.93695 6.28872 2.93112C6.92037 4.04319 7.41902 5.2257 7.77438 6.45427C7.69713 6.42636 7.61799 6.40396 7.53757 6.38725C7.10391 6.31542 6.65968 6.34137 6.23733 6.46321C5.72516 6.57678 5.25847 6.84046 4.89688 7.22056C4.59202 5.97808 4.43382 4.70416 4.42549 3.42485ZM9.56389 2.14249C10.7385 2.81949 11.6537 3.86908 12.1644 5.12499C11.8784 5.02436 11.5676 5.018 11.2777 5.10685C10.9879 5.19571 10.7341 5.3751 10.5536 5.61872C10.121 4.31507 9.36095 3.14429 8.34631 2.21845C7.93724 1.84595 7.46917 1.54397 6.96118 1.32481C7.87788 1.39771 8.76618 1.67726 9.55942 2.14249H9.56389ZM8.1095 2.50441C9.06399 3.38117 9.77909 4.48689 10.1872 5.71702C9.82375 5.60001 9.43381 5.59314 9.06647 5.6973C8.69913 5.80146 8.37083 6.01198 8.1229 6.30235C7.76033 5.05647 7.25427 3.85692 6.61489 2.72782C6.35147 2.24828 6.01789 1.81078 5.62519 1.42981C6.44734 1.42981 7.30746 1.80291 8.10503 2.50441H8.1095ZM2.09087 7.88632H2.06183C1.77858 7.76827 1.46393 7.74861 1.16819 7.83047C0.890122 7.90207 0.641116 8.05818 0.455521 8.27729C0.300183 7.15246 0.459727 6.00659 0.916428 4.96699C1.37313 3.92738 2.10911 3.03474 3.04259 2.38824C2.71022 2.8282 2.45351 3.32049 2.283 3.84486C1.87561 5.15363 1.80948 6.54481 2.09087 7.88632ZM3.39334 7.2161C3.03166 7.30451 2.70622 7.50274 2.46173 7.78355C2.19993 6.5145 2.26606 5.19965 2.65386 3.96327C2.99344 2.95793 3.54749 2.21174 4.2691 1.79844C4.11729 2.32383 4.04574 2.86914 4.05687 3.41592C4.06749 4.71242 4.22792 6.00335 4.53496 7.26301L4.42102 7.23844C4.08366 7.13273 3.72297 7.12652 3.38217 7.22056L3.39334 7.2161ZM8.65238 13.6949L9.14164 12.2003H13.1407L13.6523 13.7419C11.9846 13.62 10.3111 13.6021 8.64121 13.6882L8.65238 13.6949Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Beach = (Beach);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/CountrySide.tsx

var CountrySide = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M14.9102 7.89212H17.0477L12.5043 1.83825L10.4761 4.60037C10.4553 4.62529 10.4399 4.6542 10.4307 4.68531C10.4215 4.71642 10.4188 4.74908 10.4228 4.78127C10.4267 4.81347 10.4372 4.84451 10.4536 4.8725C10.47 4.90048 10.492 4.92481 10.5181 4.94398C10.5443 4.96316 10.5741 4.97677 10.6057 4.98398C10.6373 4.99119 10.6701 4.99185 10.702 4.98591C10.7339 4.97998 10.7642 4.96757 10.7911 4.94946C10.818 4.93136 10.8409 4.90793 10.8584 4.88062L12.5209 2.63387L16.0929 7.41712H13.9554L16.0929 10.2671H13.9554L16.0929 13.1171H14.0124V15.5871C14.0124 15.6501 14.0375 15.7105 14.082 15.7551C14.1266 15.7996 14.187 15.8246 14.2499 15.8246C14.3129 15.8246 14.3733 15.7996 14.4179 15.7551C14.4624 15.7105 14.4874 15.6501 14.4874 15.5871V13.5921H17.0406L14.9031 10.7421H17.0406L14.9102 7.89212Z",
                fill: "#BAA57E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M12.274 10.8253L9.5356 7.17013H11.2907L7.59998 2.242L3.90448 7.17013H5.66198L2.9236 10.8253H4.62885L1.95935 14.3878H6.29135V16.7628C6.29135 16.8257 6.31637 16.8862 6.36091 16.9307C6.40545 16.9752 6.46586 17.0003 6.52885 17.0003C6.59184 17.0003 6.65225 16.9752 6.69679 16.9307C6.74133 16.8862 6.76635 16.8257 6.76635 16.7628V13.9128H2.90698L5.57648 10.3503H3.87123L6.61198 6.69513H4.85448L7.59998 3.03288L10.3431 6.69513H8.5856L11.324 10.3503H9.61873L12.2906 13.9128H8.42885V16.7628C8.42885 16.8257 8.45387 16.8862 8.49841 16.9307C8.54295 16.9752 8.60336 17.0003 8.66635 17.0003C8.72934 17.0003 8.78975 16.9752 8.83429 16.9307C8.87883 16.8862 8.90385 16.8257 8.90385 16.7628V14.3878H13.2382L10.5687 10.8253H12.274Z",
                fill: "#BAA57E"
            })
        ]
    });
};
/* harmony default export */ var InspirationCategories_CountrySide = (CountrySide);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Balloon.tsx

var Balloon = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "18",
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M12.0019 1.95508C11.2197 1.22168 10.168 0.719239 8.87498 0.460938C7.90867 0.268555 7.13817 0.283203 7.00096 0.288574C6.85643 0.28418 6.08592 0.268555 5.1201 0.460938C3.82811 0.71875 2.77586 1.22168 1.99266 1.95508C0.962874 2.91943 0.431135 4.24951 0.411604 5.90918C0.389631 7.7334 1.13621 9.65967 2.63035 11.6348C3.74803 13.1123 4.93944 14.1377 5.20848 14.3623C5.22703 14.3965 5.25194 14.4287 5.28367 14.458L6.04393 15.8213C5.74803 16.0098 5.56785 16.332 5.56785 16.6855C5.56785 17.252 6.02928 17.7129 6.59617 17.7129H7.51707C8.08397 17.7129 8.5449 17.252 8.5449 16.6855C8.5449 16.3281 8.36229 16.0039 8.06151 15.8174L8.71385 14.4717C8.76073 14.4316 8.7949 14.3867 8.81737 14.3379C9.17772 14.0332 10.3359 13.0098 11.4131 11.5703C12.875 9.61719 13.6055 7.7124 13.584 5.90918C13.5635 4.24951 13.0312 2.91895 12.0019 1.95508ZM10.5137 10.8184C10.9599 9.8999 11.3154 9.07324 11.5693 8.36182C11.8867 7.47461 12.0517 6.75391 12.0586 6.21875C12.0869 4.29883 11.5762 2.79639 10.542 1.75391C10.4726 1.68457 10.4014 1.61719 10.3281 1.55176C10.8144 1.77979 11.2373 2.06152 11.5918 2.39355C12.498 3.24072 12.9658 4.42627 12.9834 5.9165C13.0029 7.56787 12.3291 9.32861 10.9805 11.1494C10.4267 11.8965 9.85057 12.5293 9.3701 13.0088C9.68748 12.4375 10.1055 11.6572 10.5137 10.8184ZM6.59569 16.2568H7.51658C7.75291 16.2568 7.94481 16.4492 7.94481 16.6855C7.94481 16.9219 7.75291 17.1143 7.51658 17.1143H6.59569C6.35985 17.1143 6.16795 16.9219 6.16795 16.6855C6.16795 16.4492 6.35985 16.2568 6.59569 16.2568ZM5.1826 6.2002C5.19188 7.11865 5.36082 8.60449 5.68602 10.6172C5.90819 11.9951 6.14012 13.2178 6.2324 13.6953C6.07811 13.708 5.93992 13.7256 5.8203 13.7471C5.60887 13.3857 4.87938 12.124 4.17283 10.6855C3.72117 9.76562 3.36131 8.94092 3.10252 8.23389C2.78856 7.375 2.62547 6.69385 2.61912 6.20996C2.59373 4.4585 3.0449 3.10205 3.96043 2.17822C4.66502 1.46826 5.51317 1.14502 6.17137 0.998535C5.67283 1.75293 5.1533 3.24902 5.1826 6.2002ZM7.17332 14.749L7.10789 15.6572H6.97117L6.85496 14.749C6.97069 14.75 7.0576 14.75 7.17332 14.749ZM7.78563 10.6094C7.56688 11.9551 7.34129 13.1445 7.23973 13.668C7.15281 13.666 7.07323 13.666 7.00584 13.666C6.95604 13.666 6.8994 13.666 6.83787 13.666C6.73582 13.1387 6.50877 11.9395 6.291 10.6016C5.96287 8.58057 5.79149 7.09766 5.7827 6.19434C5.74266 2.20947 6.73094 1.15186 7.041 0.918946C7.35057 1.14551 8.33494 2.18506 8.29588 6.19482C8.28612 7.09863 8.11522 8.5835 7.78563 10.6094ZM6.28514 15.0225L6.11082 14.71C6.15379 14.7139 6.1992 14.7188 6.24656 14.7227L6.28514 15.0225ZM7.93309 14.7061L7.75096 15.0811L7.77684 14.7207C7.83055 14.7168 7.8828 14.7119 7.93309 14.7061ZM7.84471 13.7012C7.96776 13.0605 8.18455 11.8965 8.39061 10.624C8.7158 8.61475 8.88573 7.12647 8.89549 6.20068C8.92479 3.25049 8.40526 1.75439 7.90672 0.999024C8.56444 1.14453 9.41209 1.46729 10.1162 2.17676C11.0322 3.09961 11.4844 4.45654 11.4599 6.20996C11.4521 6.7041 11.2842 7.40039 10.959 8.27881C10.6953 8.99365 10.3262 9.8335 9.86131 10.7754C9.1699 12.1738 8.45994 13.4014 8.25096 13.7578C8.13573 13.7344 8.00096 13.7158 7.84471 13.7012ZM3.5366 1.75391C2.50242 2.7959 1.99168 4.29834 2.01903 6.21875C2.02684 6.75391 2.19139 7.47461 2.5078 8.36035C2.7617 9.06982 3.11668 9.89551 3.56346 10.8154C4.00682 11.7275 4.46629 12.5781 4.80906 13.1904C4.32371 12.7178 3.67869 12.0361 3.06297 11.2139C1.68162 9.37012 0.991682 7.58789 1.0117 5.9165C1.02928 4.42725 1.49705 3.24219 2.40233 2.39355C2.79832 2.02246 3.28026 1.71484 3.83983 1.4751C3.73436 1.56348 3.63328 1.65674 3.5366 1.75391Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Balloon = (Balloon);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Gift.tsx

var Gift = function(param) {
    var width = param.width, height = param.height, fill = param.fill;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "15",
        viewBox: "0 0 29 31",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M20.4536 5.39271C19.7506 6.00829 18.6614 6.58517 17.6327 6.84498C17.1218 6.97401 16.6786 7.01122 16.3376 6.96903C16.0022 6.92754 15.8296 6.81988 15.7371 6.71427C15.6381 6.60122 15.5393 6.38633 15.5269 6.00221C15.5145 5.62049 15.5918 5.14619 15.7625 4.62587C16.1084 3.57093 16.7681 2.53219 17.4362 1.94718C18.8139 0.740646 20.4641 0.883546 21.1857 1.70752C21.9073 2.5315 21.8313 4.18618 20.4536 5.39271ZM15.1972 7.57359C15.1207 7.51391 15.0497 7.4472 14.9848 7.3731C14.8148 7.17902 14.696 6.9447 14.6218 6.68133C14.556 6.8373 14.468 6.98082 14.3557 7.10909C14.1786 7.31133 13.9508 7.46435 13.6859 7.57359H14V7.57351H15V7.57359H15.1972ZM18.6483 7.57359C19.5704 7.23173 20.4657 6.71135 21.1124 6.14501C22.7655 4.69734 23.1351 2.41564 21.938 1.0487C20.7409 -0.318239 18.4304 -0.252793 16.7773 1.19488C15.8139 2.03858 14.958 3.53302 14.6485 4.90372C14.3072 3.56427 13.3334 2.07577 12.329 1.19612C10.6755 -0.251936 8.36462 -0.317694 7.16753 1.04924C5.97044 2.41618 6.34043 4.69818 7.99394 6.14624C8.71115 6.77433 9.77785 7.29588 10.8536 7.57359H1H0V8.57359V14.5736V15.5736H1V16.5735V29.5735V30.5735H2H27H28V29.5735V16.5735V15.5736H29V14.5736V8.57359V7.57359H28H18.6483ZM13.4826 4.55375C13.0891 3.56814 12.3733 2.56421 11.6702 1.94842C10.2918 0.741329 8.64128 0.884254 7.91983 1.70807C7.19837 2.53188 7.27441 4.18685 8.65276 5.39394C9.32103 5.97918 10.438 6.49635 11.5296 6.7003C12.068 6.80089 12.5485 6.81507 12.9253 6.75247C13.3045 6.68948 13.5044 6.56326 13.6034 6.45027C13.6958 6.34473 13.7798 6.15945 13.7766 5.82146C13.7734 5.47785 13.678 5.04325 13.4826 4.55375ZM15 29.5735H27V16.5735H15L15 29.5735ZM15 14.5736H28V8.57359H15V14.5736ZM14 8.57359V14.5736H1V8.57359H14ZM14 16.5735L14 29.5735H2V16.5735H14Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Gift = (Gift);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/Wellness.tsx

var Wellness = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "19",
        height: "19",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M7.51557 1.41683C7.51352 1.41689 7.51147 1.41699 7.50942 1.41712C7.50668 1.41706 7.50395 1.41706 7.50121 1.41712C7.47355 1.4184 7.44652 1.42579 7.42205 1.43876C7.39759 1.45172 7.3763 1.46995 7.35971 1.49212C6.0407 2.71269 5.16476 3.91417 4.64411 5.07427C3.92808 4.67248 3.32685 4.55467 2.20751 4.36764C2.18424 4.35927 2.15955 4.35559 2.13485 4.3568C2.10602 4.35838 2.07795 4.36661 2.05282 4.38082C2.02145 4.39743 1.99543 4.4226 1.9778 4.4534C1.96017 4.48421 1.95164 4.51939 1.95321 4.55485C1.81951 5.37268 1.78467 6.11185 1.83397 6.77905C1.43049 6.73251 1.00347 6.70616 0.549298 6.70493C0.537034 6.70262 0.524569 6.70154 0.512091 6.70171C0.46374 6.70248 0.417557 6.7219 0.383184 6.75591C0.361075 6.77691 0.344423 6.803 0.334672 6.83189C0.324921 6.86079 0.322365 6.89163 0.327226 6.92173V7.95826C0.327226 11.1668 2.81963 13.7625 5.91743 13.7625H9.07268C12.1703 13.7625 14.6629 11.1666 14.6629 7.95826V6.92233C14.6678 6.8923 14.6654 6.8615 14.6558 6.83261C14.6462 6.80372 14.6297 6.7776 14.6078 6.75651C14.6077 6.75641 14.6076 6.75631 14.6075 6.75621C14.6072 6.75592 14.6069 6.75563 14.6066 6.75534C14.6062 6.75494 14.6058 6.75455 14.6055 6.75416C14.584 6.73356 14.558 6.71836 14.5295 6.7098C14.501 6.70124 14.4709 6.69958 14.4417 6.70495C13.9874 6.70614 13.5602 6.73226 13.1561 6.77877C13.2054 6.11117 13.1705 5.3715 13.0366 4.55307C13.0379 4.51819 13.0294 4.48363 13.0121 4.4533C12.9948 4.42297 12.9694 4.39807 12.9388 4.3814C12.9115 4.36585 12.8808 4.35739 12.8494 4.35679C12.8275 4.35641 12.8057 4.35988 12.7849 4.36704C11.6721 4.55309 11.0973 4.6715 10.3929 5.06577C9.87081 3.90842 8.99065 2.70972 7.66365 1.49187C7.64679 1.46945 7.62511 1.4511 7.60021 1.43818C7.57532 1.42525 7.54784 1.41807 7.5198 1.41717C7.51843 1.41705 7.51707 1.41696 7.5157 1.41687L7.51557 1.41683ZM7.51205 1.86477C9.6548 3.86532 10.5304 5.76132 10.6178 7.47807C9.8848 7.83249 9.29116 8.292 8.82335 8.82632C8.11087 9.64013 7.68988 10.6157 7.47892 11.63C7.27141 10.6161 6.85645 9.64067 6.14972 8.82677C5.6969 8.30529 5.12362 7.85553 4.41797 7.50459C4.50401 5.78049 5.37775 3.87414 7.51202 1.8646L7.51205 1.86477ZM2.30045 4.76457C3.32053 4.93646 3.84695 5.04789 4.49765 5.42141C4.24196 6.07574 4.09982 6.71568 4.05352 7.33736C3.51358 7.10979 2.90242 6.93738 2.21452 6.83052C2.16215 6.21638 2.18554 5.5298 2.30036 4.76457H2.30045ZM12.6898 4.76457C12.8046 5.52974 12.8279 6.21623 12.7756 6.83022C12.1086 6.93358 11.5122 7.09799 10.9832 7.3148C10.9369 6.69728 10.7949 6.06209 10.54 5.4125C11.1817 5.0454 11.6825 4.93466 12.6898 4.76446L12.6898 4.76457ZM0.702353 7.08282C3.2483 7.12085 4.86755 7.922 5.86685 9.07272C6.89069 10.2518 7.27193 11.8173 7.27193 13.3419C7.27181 13.3573 7.27358 13.3726 7.27721 13.3876H5.91753C3.02913 13.3876 0.702331 10.9732 0.702331 7.95833V7.08294L0.702353 7.08282ZM14.2879 7.08282V7.95821C14.2879 10.9731 11.9612 13.3875 9.07265 13.3875H7.67783C7.68146 13.3725 7.68323 13.3571 7.68311 13.3418C7.68311 11.8179 8.0729 10.2527 9.10547 9.07321C10.1132 7.9222 11.7414 7.12081 14.2878 7.08271L14.2879 7.08282Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var InspirationCategories_Wellness = (Wellness);

;// CONCATENATED MODULE: ./components/icons/InspirationCategories/index.ts

/* harmony default export */ var InspirationCategories = (InspirationCategories_InspirationCategoriesIcons);










;// CONCATENATED MODULE: ./blocks/search-bar/Suggestion.tsx








var Suggestion = function(param) {
    var suggestion = param.suggestion;
    var setState = (0,context/* useSearchBarContext */.J)().setState;
    var handleClick = function() {
        setState({
            selectedSuggestion: suggestion,
            searchInputValue: suggestion.text,
            showSearchSuggestions: false,
            urlObject: {
                pathname: searchTypeToPathName[suggestion.type],
                query: (0,_define_property/* default */.Z)({}, searchTypeToIdPropertyName[suggestion.type], suggestion.id)
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Suggestion_module_default()).container,
        onClick: handleClick,
        children: [
            suggestion.type === "category" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories, {
                icon: (suggestion === null || suggestion === void 0 ? void 0 : suggestion.icon) ? suggestion === null || suggestion === void 0 ? void 0 : suggestion.icon : ""
            }) : searchTypeToIcon[suggestion.type],
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Suggestion_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                        children: suggestion.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Small */.x4, {
                        xs: true,
                        color: "grey-dark",
                        children: suggestion.location
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var search_bar_Suggestion = (Suggestion);
var searchTypeToIcon = {
    hotel: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hotel, {}),
    city: /*#__PURE__*/ (0,jsx_runtime.jsx)(Location, {})
};
var searchTypeToPathName = {
    hotel: "/our-hotels/[hotelId]",
    city: "/search-results/[locationId]",
    category: "/search-results-inspirations/[inspirationId]"
};
var searchTypeToIdPropertyName = {
    hotel: "hotelId",
    city: "locationId",
    category: "inspirationId"
};

// EXTERNAL MODULE: ./components/container/index.ts
var container = __webpack_require__(49985);
// EXTERNAL MODULE: ./blocks/search-bar/MobileSearchDialog.module.scss
var MobileSearchDialog_module = __webpack_require__(33522);
var MobileSearchDialog_module_default = /*#__PURE__*/__webpack_require__.n(MobileSearchDialog_module);
// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(22715);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(91057);
;// CONCATENATED MODULE: ./components/icons/VectorIcon.tsx

var VectorIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M14.8109 13.9258L10.5072 9.61901C11.3557 8.60149 11.866 7.30115 11.866 5.88093C11.866 2.64084 9.20689 0.00634766 5.93606 0.00634766C2.66523 0.00634766 0 2.64391 0 5.884C0 9.12409 2.65908 11.7586 5.92991 11.7586C7.3194 11.7586 8.59822 11.2821 9.61267 10.4859L13.9318 14.805C14.1838 15.0571 14.5589 15.0571 14.8109 14.805C15.063 14.5529 15.063 14.1779 14.8109 13.9258ZM1.26038 5.884C1.26038 3.33866 3.3569 1.2698 5.92991 1.2698C8.50292 1.2698 10.5994 3.33866 10.5994 5.884C10.5994 8.42934 8.50292 10.4982 5.92991 10.4982C3.3569 10.4982 1.26038 8.42627 1.26038 5.884Z",
            fill: "#BAA57E"
        })
    });
};
/* harmony default export */ var icons_VectorIcon = (VectorIcon);

;// CONCATENATED MODULE: ./blocks/search-bar/constants.ts
var SEARCH_INPUT_NAME = "search-input";

;// CONCATENATED MODULE: ./blocks/search-bar/TextInput.tsx








var TextInput = function(_param) {
    var resetInputField = _param.resetInputField, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "resetInputField"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread/* default */.Z)({
        name: SEARCH_INPUT_NAME,
        type: "text",
        placeholder: "Search by destination or hotel",
        fullWidth: true,
        autoComplete: "off",
        InputProps: {
            startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_VectorIcon, {})
            }),
            endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                position: "end",
                children: typeof rest.value === "string" && rest.value.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: resetInputField,
                    title: "close",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                })
            })
        },
        sx: {
            "& .MuiInputBase-root": {
                height: "45px",
                fontWeight: 600,
                fontSize: "14px"
            },
            "& input::placeholder": {
                textTransform: "none",
                color: "#505050",
                fontWeight: 400,
                opacity: 0.9
            }
        }
    }, rest));
};
/* harmony default export */ var search_bar_TextInput = (TextInput);

// EXTERNAL MODULE: ./blocks/search-bar/Inspirations.module.scss
var Inspirations_module = __webpack_require__(79494);
var Inspirations_module_default = /*#__PURE__*/__webpack_require__.n(Inspirations_module);
;// CONCATENATED MODULE: ./blocks/search-bar/Inspirations.tsx








var Inspirations = function(param) {
    var inspirationCategories = param.inspirationCategories;
    var setState = (0,context/* useSearchBarContext */.J)().setState;
    var inspiration_text = (0,useLocalised/* default */.Z)(translationKeys.inspiration);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Inspirations_module_default()).inspirationWrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                as: "h5",
                children: inspiration_text
            }),
            inspirationCategories.map(function(inspiration, i) {
                var handleClick = function() {
                    setState({
                        searchInputValue: inspiration.name,
                        showInspirationCategories: false,
                        showSearchSuggestions: false,
                        urlObject: {
                            pathname: inspirationTypeToPathName.inspiration,
                            query: (0,_define_property/* default */.Z)({}, inspirationTypeToIdPropertyName.inspiration, inspiration.id)
                        }
                    });
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: inspiration.isSearchable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Inspirations_module_default()).inspirationContainer,
                        onClick: handleClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(InspirationCategories, {
                                icon: inspiration.icon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (Inspirations_module_default()).content,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Body */.uT, {
                                    children: inspiration.name
                                })
                            })
                        ]
                    })
                }, i);
            })
        ]
    });
};
/* harmony default export */ var search_bar_Inspirations = (Inspirations);
var inspirationTypeToPathName = {
    inspiration: "/search-results-inspirations/[inspirationId]"
};
var inspirationTypeToIdPropertyName = {
    inspiration: "inspirationId"
};

;// CONCATENATED MODULE: ./blocks/search-bar/MobileSearchDialog.tsx










var MobileSearchDialog = function(param) {
    var handleChange = param.handleChange, resetInputField = param.resetInputField, inspirationCategories = param.inspirationCategories;
    var ref = (0,context/* useSearchBarContext */.J)(), state = ref.state, setState = ref.setState;
    var showSearchSuggestions = state.showSearchSuggestions, searchInputValue = state.searchInputValue, debouncedSearchInputValue = state.debouncedSearchInputValue, searchSuggestionList = state.searchSuggestionList, noResultsFound = state.noResultsFound;
    var handleRequestClose = function() {
        setState({
            showSearchSuggestions: false
        });
    };
    var hasSuggestions = (searchSuggestionList === null || searchSuggestionList === void 0 ? void 0 : searchSuggestionList.length) > 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* default */.Z, {
        fullScreen: true,
        open: showSearchSuggestions,
        disableRestoreFocus: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (MobileSearchDialog_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                    onClick: handleRequestClose,
                    title: "close",
                    disableRipple: true,
                    className: (MobileSearchDialog_module_default()).closeBtnContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* CloseIcon */.Tw, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h5",
                    mt: "50px",
                    align: "center",
                    children: "Where are you going?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_TextInput, {
                    value: searchInputValue,
                    onChange: handleChange,
                    resetInputField: resetInputField,
                    className: (MobileSearchDialog_module_default()).searchInput
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        !hasSuggestions && (noResultsFound ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                            className: (MobileSearchDialog_module_default()).noResultFound,
                            children: [
                                "Sorry, we could't find any results for",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                                    color: "black",
                                    weight: "demiBold",
                                    className: (MobileSearchDialog_module_default()).noResultFoundText,
                                    children: [
                                        "‘",
                                        debouncedSearchInputValue,
                                        "’"
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_Inspirations, {
                            inspirationCategories: inspirationCategories
                        })),
                        hasSuggestions && /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                            mt: "40px",
                            children: searchSuggestionList === null || searchSuggestionList === void 0 ? void 0 : searchSuggestionList.map(function(searchSuggestion) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_Suggestion, {
                                    suggestion: searchSuggestion
                                }, searchSuggestion.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./blocks/search-bar/SuggestionsDropdown.module.scss
var SuggestionsDropdown_module = __webpack_require__(3906);
var SuggestionsDropdown_module_default = /*#__PURE__*/__webpack_require__.n(SuggestionsDropdown_module);
;// CONCATENATED MODULE: ./blocks/search-bar/SuggestionsDropdown.tsx











var SuggestionsDropdown = function(param) {
    var inspirationCategories = param.inspirationCategories;
    var ref = (0,context/* useSearchBarContext */.J)(), state = ref.state, setState = ref.setState;
    var debouncedSearchInputValue = state.debouncedSearchInputValue, showSearchSuggestions = state.showSearchSuggestions, searchSuggestionList = state.searchSuggestionList, noResultsFound = state.noResultsFound, showInspirationCategories = state.showInspirationCategories;
    var inspiration_text = (0,useLocalised/* default */.Z)(translationKeys.inspiration);
    // Close suggestions when clicking outside of the search input
    (0,react.useEffect)(function() {
        var handleOutsideClick = function(event) {
            var target = event.target;
            if (target.name === SEARCH_INPUT_NAME) {
                return;
            }
            setState({
                showSearchSuggestions: false,
                showInspirationCategories: false
            });
        };
        document.addEventListener("click", handleOutsideClick);
        return function() {
            document.removeEventListener("click", handleOutsideClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var shouldOpen = showSearchSuggestions && debouncedSearchInputValue.length >= 3 || showInspirationCategories;
    if (!shouldOpen) {
        return null;
    }
    var SuggestionCategory = function(param) {
        var title = param.title, suggestions = param.suggestions;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_text/* Heading */.X6, {
                    as: "h5",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* default */.Z, {
                    mt: "20px",
                    children: suggestions.map(function(suggestion) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_Suggestion, {
                            suggestion: suggestion
                        }, suggestion.id);
                    })
                })
            ]
        });
    };
    var suggestionCategories = [
        {
            title: "Destinations",
            filter: function(suggestion) {
                return suggestion.type === "city";
            }
        },
        {
            title: "Hotels",
            filter: function(suggestion) {
                return suggestion.type === "hotel";
            }
        },
        {
            title: "Inspiration",
            filter: function(suggestion) {
                return suggestion.type === "category";
            }
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: (searchSuggestionList === null || searchSuggestionList === void 0 ? void 0 : searchSuggestionList.length) === 0 ? noResultsFound ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SuggestionsDropdown_module_default()).noResultFoundContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                className: (SuggestionsDropdown_module_default()).noResultFound,
                children: [
                    "Sorry, we could't find any results for",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_text/* Body */.uT, {
                        color: "black",
                        weight: "demiBold",
                        className: (SuggestionsDropdown_module_default()).noResultFoundText,
                        children: [
                            "‘",
                            debouncedSearchInputValue,
                            "’"
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_Inspirations, {
            inspirationCategories: inspirationCategories
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (SuggestionsDropdown_module_default()).container,
            children: suggestionCategories.map(function(param) {
                var title = param.title, filter = param.filter;
                var suggestions = searchSuggestionList === null || searchSuggestionList === void 0 ? void 0 : searchSuggestionList.filter(filter);
                if (!suggestions || suggestions.length === 0) {
                    return null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SuggestionCategory, {
                    title: title,
                    suggestions: suggestions
                }, title);
            })
        })
    });
};
/* harmony default export */ var search_bar_SuggestionsDropdown = (SuggestionsDropdown);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./hooks/useDropDown.ts
var useDropDown = __webpack_require__(85080);
;// CONCATENATED MODULE: ./blocks/search-bar/SearchBar.tsx
















var SearchBar = function(param) {
    var inspirationCategories = param.inspirationCategories;
    var ref = (0,context/* useSearchBarContext */.J)(), state = ref.state, setState = ref.setState;
    var searchInputValue = state.searchInputValue, urlObject = state.urlObject;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useDropDown/* default */.Z)(), isOpen = ref1.isOpen, dropdownRef = ref1.dropdownRef, setIsOpen = ref1.setIsOpen;
    var handleChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                setState({
                    searchInputValue: e.target.value
                });
                return [
                    2
                ];
            });
        });
        return function handleChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var resetInputField = function(e) {
        e.stopPropagation();
        setState({
            searchInputValue: ""
        });
    };
    var handleSearchInputFocus = function() {
        if (isOpen) {
            return;
        }
        setState({
            showSearchSuggestions: true,
            showInspirationCategories: true
        });
        setIsOpen(true);
    };
    var handleSearchClick = function(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        if (!urlObject) {
            return;
        }
        router.push(urlObject);
    };
    var search_hotels_text = (0,useLocalised/* default */.Z)(translationKeys.search_hotels);
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:".concat(constants/* breakpoints.sm */.AV.sm, ")"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "search-input",
        ref: dropdownRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "search-input__container",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "search-input__section",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "search-input__text-field",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_TextInput, {
                                name: SEARCH_INPUT_NAME,
                                onFocus: handleSearchInputFocus,
                                value: searchInputValue,
                                onChange: handleChange,
                                resetInputField: resetInputField
                            }),
                            isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileSearchDialog, {
                                handleChange: handleChange,
                                resetInputField: resetInputField,
                                inspirationCategories: inspirationCategories
                            }),
                            isOpen && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_SuggestionsDropdown, {
                                inspirationCategories: inspirationCategories
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                        title: search_hotels_text,
                        onClick: handleSearchClick,
                        className: "search-input__button",
                        buttonType: Button/* FILLED_BUTTON_TYPE_DARK */.HB
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var search_bar_SearchBar = (SearchBar);

;// CONCATENATED MODULE: ./blocks/search-bar/SearchBarContainer.tsx









var SearchBarContainer = function(param) {
    var inspirations = param.inspirations, initialSearchValue = param.initialSearchValue;
    var ref = (0,context/* useSearchBarContext */.J)(), state = ref.state, setState = ref.setState;
    var searchInputValue = state.searchInputValue;
    (0,react.useEffect)(function() {
        if (initialSearchValue !== undefined) {
            setState({
                searchInputValue: initialSearchValue
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialSearchValue
    ]);
    // Debounce the search value to avoid unnecessary API calls
    var debouncedSearchInputValue = (0,useDebounce/* default */.Z)(searchInputValue, 200);
    // Fetch the search suggestion list
    var ref1 = (0,useQuery/* useQuery */.a)([
        GET_SEARCH_SUGGESTION_LIST,
        debouncedSearchInputValue
    ], function() {
        return (0,misc/* getSearchSuggestionList */.sM)(debouncedSearchInputValue);
    }, {
        keepPreviousData: true,
        staleTime: 1000 * 60
    }), searchSuggestionList = ref1.data, isLoadingSearchSuggestionList = ref1.isLoading;
    var noResultsFound = react.useMemo(function() {
        return (searchSuggestionList === null || searchSuggestionList === void 0 ? void 0 : searchSuggestionList.length) === 0 && !isLoadingSearchSuggestionList && debouncedSearchInputValue.length >= 3;
    }, [
        searchSuggestionList,
        isLoadingSearchSuggestionList,
        debouncedSearchInputValue
    ]);
    // Sync the data state with the current context state
    react.useEffect(function() {
        setState({
            searchSuggestionList: searchSuggestionList,
            isLoadingSearchSuggestionList: isLoadingSearchSuggestionList,
            debouncedSearchInputValue: debouncedSearchInputValue,
            noResultsFound: noResultsFound
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        searchSuggestionList
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(search_bar_SearchBar, {
        inspirationCategories: inspirations
    });
};
/* harmony default export */ var search_bar_SearchBarContainer = (SearchBarContainer);

;// CONCATENATED MODULE: ./blocks/search-bar/index.ts



/***/ }),

/***/ 4841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useDebounce = function(value) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value), debouncedValue = ref[0], setDebouncedValue = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handler = setTimeout(function() {
            setDebouncedValue(value);
        }, delay);
        return function() {
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
};
/* harmony default export */ __webpack_exports__["Z"] = (useDebounce);


/***/ }),

/***/ 85080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useDropdown = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    /**
   * Controls closing the dropdown when clicking outside of it.
   * @param {MouseEvent | TouchEvent} event - The triggered event.
   */ var handleClickOutside = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (!(dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current)) {
            return;
        }
        if (dropdownRef.current.contains(event.target)) {
            return;
        }
        if (isOpen) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
            setIsOpen(false);
        }
    }, [
        isOpen
    ]);
    /**
   * Listens for clicks outside of the dropdown element to close it
   * and stops propagation to prevent other click handlers from firing.
   * Events to listen: touchend, click (touchable devices and desktops).
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("touchend", handleClickOutside, true);
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            document.removeEventListener("touchend", handleClickOutside, true);
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        handleClickOutside
    ]);
    var closeDropdown = function() {
        setIsOpen(false);
    };
    var toggleDropdown = function() {
        setIsOpen(function(prev) {
            return !prev;
        });
    };
    return {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        dropdownRef: dropdownRef,
        closeDropdown: closeDropdown,
        toggleDropdown: toggleDropdown
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useDropdown);


/***/ }),

/***/ 79494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"Inspirations_inspirationWrapper__njNrV","inspirationContainer":"Inspirations_inspirationContainer__AZOh2","content":"Inspirations_content__tPeu_"};

/***/ }),

/***/ 33522:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileSearchDialog_container__hzBlc","closeBtnContainer":"MobileSearchDialog_closeBtnContainer__cBovp","searchInput":"MobileSearchDialog_searchInput__5LABv","noResultFound":"MobileSearchDialog_noResultFound__Rxh_s","noResultFoundText":"MobileSearchDialog_noResultFoundText__7S_mK"};

/***/ }),

/***/ 36194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Suggestion_container__QBaHg","content":"Suggestion_content__QJs6o"};

/***/ }),

/***/ 3906:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionsDropdown_container__UXZe4","noResultFoundContainer":"SuggestionsDropdown_noResultFoundContainer__UI6sO","noResultFoundText":"SuggestionsDropdown_noResultFoundText__xHpjC","inspirationWrapper":"SuggestionsDropdown_inspirationWrapper__cj2x6","inspirationContainer":"SuggestionsDropdown_inspirationContainer__GAtV9","content":"SuggestionsDropdown_content__9eMug"};

/***/ })

}]);